import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useLayoutEffect, useEffect } from "react";
import Main from "./components/Main";
import StickyFooter from "./components/StickyFooter";
import CCRM from "./components/ccrm";
import Contacto from "./components/Contacto";
import BlockBackground from "./components/block-background";

import ERP from "./components/ERP";
import SOPORTEIT from "./components/soporteit";
import AccountsUpload from "./components/AccountsUpload";
import Aos from "aos";

function App() {
  useEffect(() => {
    Aos.init({duration: 3000});
  },[]);

  const Wrapper = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
      document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    return children;
  };

  return (
    <>
      <Wrapper>
        <Routes>
          <Route path="/" element={<Main/>} />
          <Route path="/contacto" element={<Contacto/>} />

          <Route path="/ERP" element={<ERP/>} />
          <Route path="/soporteit" element={<SOPORTEIT/>} />
          <Route path="/ccrm" element={<CCRM/>} />
          <Route path="/cargas-chocotec" element={<AccountsUpload />} />
          <Route path="/block-background" element={<BlockBackground />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Wrapper>
      <StickyFooter/>
    </>
  );
}

export default App;
